import { render, staticRenderFns } from "./GridCheckboxRender.vue?vue&type=template&id=04ecb802&"
import script from "./GridCheckboxRender.vue?vue&type=script&lang=js&"
export * from "./GridCheckboxRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports